import { render } from "./Companies.vue?vue&type=template&id=1be8f624&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"

import "./Companies.vue?vue&type=style&index=0&id=1be8f624&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1be8f624"

export default script